import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

export function LanguageSelect() {
  const { t, i18n } = useTranslation('translation')
  return (
    <div>
      <h1>{t('languageSelection.title')}</h1>
      <Label>
        <input
          name="lang"
          type="radio"
          value="pl"
          onChange={() => i18n.changeLanguage('pl')}
          defaultChecked
        />
        <span />
        {t('languageSelection.options.1')}
      </Label>
      <Label>
        <input
          name="lang"
          type="radio"
          value="en"
          onChange={() => i18n.changeLanguage('en')}
        />
        <span />
        {t('languageSelection.options.2')}
      </Label>
      <Label>
        <input
          name="lang"
          type="radio"
          value="ua"
          onChange={() => i18n.changeLanguage('ua')}
        />
        <span />
        {t('languageSelection.options.3')}
      </Label>
      <Label>
        <input
          name="lang"
          type="radio"
          value="vi"
          onChange={() => i18n.changeLanguage('vi')}
        />
        <span />
        {t('languageSelection.options.4')}
      </Label>
    </div>
  )
}

const Label = styled.label`
  padding-right: 1rem;
  overflow: hidden;
  margin-top: 2rem;
  display: flex;
  align-items: center;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, var(--color-text));
  width: 100%;
  background-color: var(--color-background);
  border-radius: 10px;
  border: 1px solid var(--color-text);
  input[type='radio'] {
    position: absolute;
    clip: rect(0 0 0 0);
  }
  input[type='radio']:checked ~ span::before {
    background-color: var(--color-primary);
  }
  input[type='radio']:focus ~ span::before {
    outline: 1px solid blue;
  }

  > span {
    margin-right: 1rem;
    padding: 1rem 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--color-background-light);

    &::before {
      content: '';
      position: relative;
      border-radius: 100%;
      height: 16px;
      width: 16px;
      background-color: var(--color-background);
    }

    &::after {
      content: '';
      position: absolute;
      border-radius: 50%;
      height: 8px;
      width: 8px;
      background-color: var(--color-background);
    }
  }
`
